const FLAGS = {
  DECK_BUILDER: process.env.PARCEL_DECK_BUILDER === "true" ? true : false,
  DEEP_INSIGHTS: process.env.PARCEL_DEEP_INSIGHTS === "true" ? true : false,
};

export default FLAGS;
